import { ThemeEvents } from "@theme/events";

class ProductSku extends HTMLElement {
    connectedCallback() {
        const section = this.closest(".shopify-section, dialog");
        if (!section) return;
        section.addEventListener(
            ThemeEvents.variantUpdate,
            this.#onVariantUpdate
        );
    }

    disconnectedCallback() {
        const section = this.closest(".shopify-section, dialog");
        if (!section) return;
        section.removeEventListener(
            ThemeEvents.variantUpdate,
            this.#onVariantUpdate
        );
    }

    /**
     * @param {CustomEvent & { detail: { data: { html: Document, newProduct?: { id: string }, productId: string } } }} event
     */
    #onVariantUpdate = (event) => {
        // Controla multi-produto (combined listings) igual ao price
        if (event.detail.data.newProduct) {
            this.dataset.productId = event.detail.data.newProduct.id;
        } else if (
            event.target instanceof HTMLElement &&
            event.target.dataset.productId !== this.dataset.productId
        ) {
            return;
        }

        const fresh = event.detail.data.html.querySelector("product-sku");
        if (!fresh) return;

        const freshValue = fresh.querySelector('[ref="skuValue"]');
        const currentValue = this.querySelector('[ref="skuValue"]');

        if (!freshValue || !currentValue) return;

        const newText = freshValue.textContent?.trim();
        const hasNew = newText && newText.length > 0;

        // Atualiza texto
        if (currentValue.textContent !== freshValue.textContent) {
            currentValue.textContent = freshValue.textContent;
        }

        // Mostra / esconde se não houver SKU
        if (hasNew) {
            this.removeAttribute("hidden");
        } else {
            this.setAttribute("hidden", "");
        }
    };
}

if (!customElements.get("product-sku")) {
    customElements.define("product-sku", ProductSku);
}
